<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    :total="total"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    @pageClick="getList"
    :inputType="1"
    @operClick="operClick"
    @exportExc="exportExc"
    :listPage="true"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    ref="common"
    :tableHeight="600"
  >
    <template slot="select">
      <FormItem>
        <Select
          v-model="searchFrom.warehouse_id"
          class="search-select"
          filterable
          clearable
          :placeholder="$t('select') + $t('warehouseName')"
          :filter-by-label="true"
        >
          <Option
            v-for="item in warehouseList1"
            :value="item.id"
            :key="item.id"
            :label="item.title"
          ></Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select
          v-model="searchFrom.client_id"
          filterable
          clearable
          :placeholder="$t('select') + $t('clientName')"
          class="search-select"
          :filter-by-label="true"
        >
          <Option
            v-for="item in clientList"
            :value="item.id"
            :key="item.id"
            :label="item.account"
          ></Option>
        </Select>
      </FormItem>
    </template>
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick('add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('order_number')" prop="airway_number">
            <i-Input
              type="textarea"
              v-model="dataDetails.airway_number"
              placeholder="Please Enter airway_number"
              :rows="6"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('warehouseName')" prop="warehouse_id">
            <Select
              v-model="dataDetails.warehouse_id"
              filterable
              clearable
              placeholder="Please Select warehouse"
              :filter-by-label="true"
            >
              <Option
                v-for="item in warehouseList"
                :value="item.id"
                :key="item.id"
                :label="item.title"
              >
              </Option>
            </Select>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { getOriPack, getPackWare, postAdd } from "@/api/storage/ori_pack";
import { getAllClient } from "@/api/user/client";

import bosMes from "@/utils/message";

import common from "_c/common-body";
import excel from "@/utils/excel";
import { getWarehouse } from "@/api/storage/warehouse";

export default {
  // name:'小包出库',
  components: {
    common
  },
  watch: {
    dataDetails: {
      handler: function(nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      warehouseList1: [],
      hideSelect: true,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      loading: false,
      list: [],
      list2: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        pickupStatus: "-1",
        client_id: "",
        keywords: "",
        is_process: "NO"
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      typeList: [
        this.$t("up"),
        this.$t("Picking"),
        this.$t("picking_t") + this.$t("complete")
      ],
      id: "",
      warehouse: "", //仓库列表
      sku_code: "",
      hasclient_id: true,
      selectAll: [],
      order: "", //新增出货的单号组
      adddata: [],
      tabledata: [],
      printtype: "",
      clientList: [],
      warehouseList: [],
      ruleFrom: {
        airway_number: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "bulr"
          }
        ],
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      if (this.hideSelect) {
        columns.push({
          type: "selection",
          width: 60,
          align: "center"
        });
      }
      columns.push({
        title: this.$t("shipperRef"),
        key: "sku_name",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      columns.push({
        title: this.$t("transfer_num"),
        key: "airway_number",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      columns.push({
        title: this.$t("clientName"),
        key: "client_name",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      columns.push({
        title: this.$t("countryCode"),
        key: "country_code",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      columns.push({
        title: this.$t("location"),
        key: "location",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      columns.push({
        title: this.$t("warehouseName"),
        key: "warehouse_title",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      columns.push({
        title: this.$t("exlType"),
        align: "center",
        tooltip: true,
        key: "pickupStatus_txt",
        minWidth: 80,
        render: (h, { row }) => {
          return h(
            "span",
            {
              style: {
                color: row.pickupStatus_txt == this.$t("Picking") ? "red" : ""
              }
            },
            row.pickupStatus_txt
          );
        }
      });
      columns.push({
        title: this.$t("onlineTime"),
        key: "onlineTime",
        align: "center",
        tooltip: true,
        minWidth: 180
      });
      columns.push({
        title: this.$t("operate"),
        key: "operator_name",
        align: "center",
        tooltip: true,
        minWidth: 100
      });
      return columns;
    }
  },

  mounted() {
    this.getList();
    this.getOtherList();
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.closedeleteModal(false);
      } else {
        this.confirm("dataDetails");
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.addList();
        }
      });
    },
    addList() {
      postAdd(this.dataDetails).then(res => {
        bosMes.alertMes(res, this);
      });
    },
    crudClick(text) {
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.dataDetails = {};
      this.preForm = {};
      this.isshowModal = true;
      this.crudText = text;
    },
    exportExc() {
      this.hideSelect = false;
      let arr = this.tableTitle;
      // arr.pop();

      excel.exportExcel(
        this.selectAll.length == 0 ? this.list : this.selectAll,
        arr,
        this.$t("ori_pack"),
        this
      );
      this.hideSelect = true;
    },
    operClick(val) {
      this.selectAll = val;
    },
    getOtherList() {
      getAllClient().then(res => {
        this.clientList = res.data.payload.rows;
      });
      getPackWare().then(res => {
        this.warehouseList = res.data.payload;
      });
      getWarehouse({ is_oversea: "YES" }).then(res => {
        this.warehouseList1 = res.data.payload.rows;
      });
    },
    SearchSubmit() {
      this.getList();
    },
    getList() {
      this.loading = true;
      getOriPack(this.searchFrom)
        .then(res => {
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows.map(item => {
            item.pickupStatus_txt =
              item.pickupStatus == 1
                ? this.$t("Picking")
                : item.pickupStatus == 0
                ? this.$t("Picking")
                : this.$t("picking_t") + this.$t("complete");
            return item;
          });
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}

.ivu-page {
  margin-top: 20px;
}
</style>
